  import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
  import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';


  /**
* APIConfiguration entity interface.
*/
export interface IAPIConfiguration {
ClientId?: string;
ClientSecret?: string;
Resource?: string;
GrantType?: string;
APIUrl?: string;
LoginUrl?: string;
AnnotationUrl?: string;
}

/**
* ContainerLine entity interface.
*/
export interface IContainerLine {
ContainerId?: string;
ItemId?: string;
ItemDescription?: string;
Quantity: number;
}

/**
* Container entity interface.
*/
export interface IContainer {
ContainerId?: string;
Carrier?: string;
ShippingType?: string;
MasterTrackingNum?: string;
ShipmentTrackingNum?: string;
ProNum?: string;
BillOfLadingNum?: string;
ShipFromWarehouse?: string;
TrackingURL?: string;
ContainerLines?: IContainerLine[];
}

/**
* GCOrderTrackingInfo entity interface.
*/
export interface IGCOrderTrackingInfo {
Status?: string;
Message?: string;
Containers?: IContainer[];
ExtensionProperties?: Entities.CommerceProperty[];
}

/**
 * ContainerLine entity class.
 */
export class ContainerLineExtensionClass implements IContainerLine {

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ContainerId: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ItemId: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ItemDescription: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public Quantity: number;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
    odataObject = odataObject || {};
          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.ContainerId = odataObject.ContainerId;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.ItemId = odataObject.ItemId;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.ItemDescription = odataObject.ItemDescription;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.Quantity = odataObject.Quantity;

    }
}

/**
 * Container entity class.
 */
export class ContainerExtensionClass implements IContainer {

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ContainerId: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public Carrier: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ShippingType: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public MasterTrackingNum: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ShipmentTrackingNum: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ProNum: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public BillOfLadingNum: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ShipFromWarehouse: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public TrackingURL: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ContainerLines:
          IContainerLine[];

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
    odataObject = odataObject || {};
          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.ContainerId = odataObject.ContainerId;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.Carrier = odataObject.Carrier;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.ShippingType = odataObject.ShippingType;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.MasterTrackingNum = odataObject.MasterTrackingNum;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.ShipmentTrackingNum = odataObject.ShipmentTrackingNum;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.ProNum = odataObject.ProNum;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.BillOfLadingNum = odataObject.BillOfLadingNum;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.ShipFromWarehouse = odataObject.ShipFromWarehouse;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.TrackingURL = odataObject.TrackingURL;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      this.ContainerLines = undefined;
      if (odataObject.ContainerLines) {
        this.ContainerLines = [];
        for (var i = 0; i < odataObject.ContainerLines.length; i++) {
          if (odataObject.ContainerLines[i]) {
      if (odataObject.ContainerLines[i]['@odata.type']) {
        var className: string = odataObject.ContainerLines[i]['@odata.type'];
        className = className.substr(className.lastIndexOf('.') + 1).concat("Class");
        //@ts-ignore
        if (EntityClasses[className]) {
          //@ts-ignore
          this.ContainerLines[i] = new EntityClasses[className](odataObject.ContainerLines[i]);
        }
      } else {
        this.ContainerLines[i] = new ContainerLineExtensionClass(odataObject.ContainerLines[i]);
      }

          } else {
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.ContainerLines[i] = undefined;
          }
        }
      }

    }
}


/**
 * GCOrderTrackingInfo entity class.
 */
export class GCOrderTrackingInfoExtensionClass implements IGCOrderTrackingInfo {

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public Status: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public Message: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public Containers:
          IContainer[];

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ExtensionProperties: Entities.CommerceProperty[];

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
    odataObject = odataObject || {};
          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.Status = odataObject.Status;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.Message = odataObject.Message;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      this.Containers = undefined;
      if (odataObject.Containers) {
        this.Containers = [];
        for (var i = 0; i < odataObject.Containers.length; i++) {
          if (odataObject.Containers[i]) {
      if (odataObject.Containers[i]['@odata.type']) {
        var className: string = odataObject.Containers[i]['@odata.type'];
        className = className.substr(className.lastIndexOf('.') + 1).concat("Class");
        //@ts-ignore
        if (EntityClasses[className]) {
          //@ts-ignore
          this.Containers[i] = new EntityClasses[className](odataObject.Containers[i]);
        }
      } else {
        this.Containers[i] = new ContainerExtensionClass(odataObject.Containers[i]);
      }

          } else {
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.Containers[i] = undefined;
          }
        }
      }

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      this.ExtensionProperties = undefined;
      if (odataObject.ExtensionProperties) {
        this.ExtensionProperties = [];
        for (i = 0; i < odataObject.ExtensionProperties.length; i++) {
          if (odataObject.ExtensionProperties[i]) {
      if (odataObject.ExtensionProperties[i]['@odata.type']) {
        var className2: string = odataObject.ExtensionProperties[i]['@odata.type'];
        className2 = className2.substr(className2.lastIndexOf('.') + 1).concat("Class");
        //@ts-ignore
        if (EntityClasses[className2]) {
          //@ts-ignore
          this.ExtensionProperties[i] = new EntityClasses[className2](odataObject.ExtensionProperties[i]);
        }
      } else {
        this.ExtensionProperties[i] = new EntityClasses.CommercePropertyClass(odataObject.ExtensionProperties[i]);
      }

          } else {
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.ExtensionProperties[i] = undefined;
          }
        }
      }

    }
}

/**
 * APIConfiguration entity class.
 */
export class APIConfigurationExtensionClass implements IAPIConfiguration {

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ClientId: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public ClientSecret: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public Resource: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public GrantType: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public APIUrl: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public LoginUrl: string;

      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      public AnnotationUrl: string;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
    odataObject = odataObject || {};
          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.ClientId = odataObject.ClientId;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.ClientSecret = odataObject.ClientSecret;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.Resource = odataObject.Resource;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.GrantType = odataObject.GrantType;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.APIUrl = odataObject.APIUrl;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.LoginUrl = odataObject.LoginUrl;

          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.AnnotationUrl = odataObject.AnnotationUrl;

    }
}